import { Obj } from '.';
export class Num {
/**
 * Returns whether the given value is a number
 * @param {?} value
 * @return {?}
 */
public static isNumber(value: any): boolean {
    return Obj.isNotNullOrUndefined(value) && typeof value === "number" && !isNaN(value);
  }
/**
 * Returns whether any of the numbers in the given list of arguments
 * are not a number.
 * that is not a number.
 * @param {...?} nums
 * @return {?}
 */
public static isNaN(...nums: any[]): boolean {
    if(!nums || nums.length == 0) {
      return true;
    }

    let /** @type {?} */ test = false;
    nums.forEach((num: number) => {
      if(!Num.isNumber(num)) {
        test = true;
      }
    });
    return test;
  }
/**
 * Returns whether any of the given arguments are negative numbers
 * @param {...?} args
 * @return {?}
 */
public static isNegative(...args: number[]): boolean {
    return !Num.isNonNegative(...args);
  }
/**
 * Returns whether all of the given arguments are non-negative numbers
 * @param {...?} args
 * @return {?}
 */
public static isNonNegative(...args: number[]): boolean {
    let /** @type {?} */ test = true;
    args.forEach((num: number) => {
      if (Num.isNumber(num) && num < 0) {
        test = false;
      };
    });
    return test;
  }
/**
 * Returns whether the two given numbers have the same mathematical sign.
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
public static sameSign(a: number, b: number): boolean {
    return a * b >= 0;
  }
/**
 * Returns a dictionary of enum name as a string to its enum value as a number
 * @param {?} list
 * @return {?}
 */
public static getEnumDictionary(list: any): any {
    let /** @type {?} */ names = Num.getEnumNames(list);
    let /** @type {?} */ enums = Num.getEnumValues(list);
    let /** @type {?} */ dictionary = {};

    for(let /** @type {?} */ i = 0; i < names.length; i++) {
      dictionary[names[i]] = enums[i];
    }

    return dictionary;
  }
/**
 * Returns an enum list as an array of enum string names
 * @param {?} list
 * @return {?}
 */
public static getEnumNames(list: any): string[] {
    if(Obj.isNullOrUndefined(list)) {
      throw Error('Enum list is null or undefined; cannot get names');
    }
    let /** @type {?} */ names = [];

    for(let /** @type {?} */ k in list) {
      let /** @type {?} */ value = list[k];
      if(Num.isNaN(value)) {
        names.push(value);
      }
    }

    return names;
  }
/**
 * Returns a list of enum values as an array of numbers
 * @param {?} list
 * @return {?}
 */
public static getEnumValues(list: any): number[] {
    if(Obj.isNullOrUndefined(list)) {
      throw Error('Enum list is null or undefined; cannot get values');
    }

    let /** @type {?} */ enums = [];

    for(let /** @type {?} */ k in list) {
      let /** @type {?} */ value = list[k];
      if(!Num.isNaN(value)) {
        enums.push(value);
      }
    }

    return enums;
  }
}